import axios from 'axios';
import { getAiChatApiBase } from '../config';

function authHeaders() {
  const token = window.localStorage.getItem('accessToken');
  return token ? { Authorization: token } : {};
}

/**
 * Shared axios instance for AI Chat REST calls only.
 */
export function createAiChatHttpClient() {
  const base = getAiChatApiBase();
  if (!base) {
    return null;
  }
  const client = axios.create({
    baseURL: base,
    timeout: 120000,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(),
    },
  });

  client.interceptors.request.use((config) => {
    const next = { ...config };
    next.headers = {
      ...next.headers,
      ...authHeaders(),
    };
    return next;
  });

  return client;
}
